import { Component, OnInit, Injector, AfterViewInit } from '@angular/core';
import { storeCategories, flatTagMenu, IAppStoreProduct } from '../interfaces/appstore-interfaces';
import { AppComponentBase } from '../../../services/AppComponentBase';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { ICategory, IInternalTag } from '../../../api/DixApiClient';

//import * as Shopify from "shopify-api-node";
import { filter } from 'rxjs/operators';
import {Utils} from '../../../utils';

//const Shopify = require('shopify-api-node');

@Component({
  selector: 'app-appstore-mainview',
  template: require('./appstore-mainview.component.html'),
  styles: [require('./appstore-mainview.component.scss')]
})
export class AppstoreMainviewComponent extends AppComponentBase  implements OnInit, AfterViewInit {

 

  ngAfterViewInit (): void {

    $(".products").mCustomScrollbar({
                  axis: "y",
                  theme: "inset-3", // "minimal-dark",
                  scrollbarPosition: "outside",
                  alwaysShowScrollbar: 0, // 0,1,2
                  scrollButtons: {
                      enable: true
                  },
                  mouseWheel: {
                      enable: true,
                      scrollAmount: 75
                  }
              });

            
  }

  constructor(
    injector: Injector,
  ) { 
    super(injector);
  }

  ngOnInit() {

    

  }

  public openPopup(myURL:any, title:any, myWidth:any, myHeight:any) 
    {
        Utils.openPopup(myURL, title, myWidth, myHeight);
    }
    
  public apiTest()
  {
   // let c= new Shopify()
    // let shopify = new Shopify({
    //   shopName: 'infosystrade-test',
    //   apiKey: 'de10c79aefe7cc946d100ac27e709540',
    //   password: '06bb2c1a69ee290442685c2cb50f6ac8'
    // });

    //shopify.
    //shopify.product.list().then()
  }

  private _categories: ICategory[] = [];
  public get categories (): ICategory[] {
    return this.workspace.storeCategories;
  }
  public set categories ( value: ICategory[] ) {
    this._categories = value;
  }

  private _tagsMenu: IInternalTag[] = [];
  public get tagsMenu (): IInternalTag[] {
    return  this.workspace.storeTagsMenu;
  }
  public set tagsMenu ( value: IInternalTag[] ) {
    this._tagsMenu = value;
  }

  private _selectedMenuItem: number = -1;
  public get selectedMenuItem (): number {
    return this._selectedMenuItem;
  }
  public set selectedMenuItem ( value: number ) {
    this._selectedMenuItem = value;
  }


  private _productList: IAppStoreProduct[] = [];
  public get productList (): IAppStoreProduct[] {

    return this.workspace.producsList.filter(v=>{

      if(this.filterAppsUser)
      {
         return v.access == this.filterAppsUser
      }
      else
      {
        return true
      }
     
    // }).filter(l=>{

    //   if(this.selecteCategory>=0)
    //   {
    //      return l.categories!.indexOf(this.selecteCategory)>-1
    //   }
    //   else
    //   {
    //     return true
    //   }

    }).filter(k=>{
        if(this.selectedMenuItem==-1)
        {
          return true
        }
        else
        {
          return k.tags!.indexOf(this.selectedMenuItem)>-1
        }
    })

    ;
  }

  public productFilteredByCategory(id:number)
  {
      let products = this.productList.filter(v=>{
        if(v.categories)
        {
          return v.categories.indexOf(id)>=0
        }
      })
      return products;
  }

  public productWIthoutCategories(id:number)
  {
      return this.workspace.producsList.filter(v=>{
        if(v.categories)
        {
          return v.categories.indexOf(id)<0;
        }
      })
  }


  public set productList ( value: IAppStoreProduct[] ) {
    this._productList = value;
  }



  private _selectedCategoryName: string = "";
  public get selectedCategoryName (): string {
    return this._selectedCategoryName;
  }
  public set selectedCategoryName ( value: string ) {
    this._selectedCategoryName = value;
  }


  private _selecteCategory: any;
  public get selecteCategory (): any {
    return this._selecteCategory;
  }

  public set selecteCategory ( value: any ) {
    this._selecteCategory = value;
  }

  public onCategoryChange(e:any)
  {
    this.selecteCategory = e.id;
    this.selectedCategoryName = e.name;
  }

  private _filterAppsUser: boolean = false;
  public get filterAppsUser (): boolean {
    return this._filterAppsUser;
  }
  public set filterAppsUser ( value: boolean ) {
    this._filterAppsUser = value;
  }

  public filterAppsByUser(val:boolean)
  {
      this.filterAppsUser = val;
  }




}

